import React, { useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux'
import moment from 'moment';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import HighstocksComponent from '../../components/Highstocks/HighstocksComponent';
import { useHistory } from "react-router-dom";
import {
  selectedDateRange,
  changeRangeDate,
  DashboardState,
  changeTabs,
  getAllResultsDashboard,

} from './DashboardPageActions';
import { Statistic, Icon, Card, Grid, Progress, Breadcrumb, Button, Input, Search, Accordion, Badge } from '@scuf/common';
import baseServices from "../../services/base.services";
import { Chart, Gauge, CircleGauge } from '@scuf/charts';
import Pareto from '../../components/Charts/Pareto/Pareto';
import UseTimeSeries from '../../customHook/useTimeSeries';
import UseSelectedDiv from '../../customHook/useSelectedDiv';

import UseSparkline from '../../customHook/useSparkLine';
import SparkLineComponent from '../../components/Charts/SparkLine/SparkLineComponent';
import TimeSeriesComponent from '../../components/TimeSeries/TimeSeriesComponent';
import UseTabs from '../../customHook/useTabs';
import UseDateRange from '../../customHook/useDateRange';
import LineChart from '../../components/LineChart';
import styles from './DashboardPageStyle.scss';
import MessageInfoComponent from '../../components/MessageInfo/MessageInfoComponent';


export interface PropsDetailDataList {
  title: any | null;
  value: any | null;
  icon: any | null;
}

export const DetailDataList = (data: PropsDetailDataList) => {
  return <div style={{ padding: '5px' }}>
    <div className='text-center border-gray' style={{ padding: '0px', width: '100%' }}>
      <div style={{
        position: 'absolute',
        marginLeft: '20px',
        fontSize: '30px',
        marginTop: '7px',
        color: '#1792e5'
      }}>{data.icon}</div>
      <span style={{
        fontSize: '15px', fontWeight: 700, marginRight: '5px',
        marginLeft: '5px'

      }}
      >{data.value}</span>
      <span className='title'>
        <span style={{ textTransform: 'uppercase', fontSize: '10px' }}></span>
      </span>
      <div style={{ fontSize: '7px' }}>{data.title}</div>
    </div>
  </div>
}

export const CircularChart = (data: any) => {
console.log(data);
  return <div style={{ height: '300px', paddingLeft: '10px', paddingRight: '10px', paddingTop: '20px', paddingBottom: '20px' }}>
    <Chart height='200'
    >
    {/*@ts-ignore */}
    <Chart.Pie
      data={data.data}
    >
      <Chart.CenterBlock>

      </Chart.CenterBlock>
    </Chart.Pie>
    < Chart.Legend enabled={true} position='right middle'></Chart.Legend>
  </Chart>
  </div>
}

function DashboardPage(propsPage: DashboardState | null) {
  const selectedRange = useAppSelector(selectedDateRange);
  const history: any = useHistory();
  {/* @ts-ignore */ }

  const dispatch = useAppDispatch();


  const handlerSelectedTabs = (data: any) => {
    dispatch(changeTabs(data));
   // dispatch(getAllResultsDashboard({ processID: data.id, period: propsPage?.selectedRange }))
  }

  const handlerDate = (data: any) => {
    dispatch(changeRangeDate(data.id));
    dispatch(getAllResultsDashboard({ period: data.id }))
  }


  useEffect(() => {
    dispatch(getAllResultsDashboard({ period: propsPage?.selectedRange }))
  }, [dispatch])


  return (
    <Grid>
      <Grid.Row >
        <h4 className='title-page'> Dashboard</h4>
      </Grid.Row>
      <Grid.Row>

        <Grid.Column width={4} sWidth={12}>

        </Grid.Column>

        <Grid.Column width={4} sWidth={12}>

        </Grid.Column>
        <Grid.Column width={4} sWidth={12} className='justify-content-center align-self-center text-center' >
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={5} sWidth={12} className='d-flex align-items-center'>
        </Grid.Column>
        <Grid.Column width={2} sWidth={12}>
          <div className='no-show-movil' style={{
            margin: '0px auto',
            //       width: '240px'
          }}>
            {/*@ts-ignore */}
            <UseDateRange callback={handlerDate}>

            </UseDateRange>
          </div>
        </Grid.Column>
        <Grid.Column width={5} sWidth={12} className='d-flex align-items-center'>
          <div style={{ textAlign: 'right', width: '100%', paddingRight: '10px', fontSize: '20px', color: '#45a7ea' }}>
            <span className='show-only-movil' style={{ marginRight: '0px', fontWeight: 700, fontSize: '18px', cursor: 'pointer' }}
              onClick={() => handlerDate({ id: propsPage?.selectedRange == 'D' ? 'W' : propsPage?.selectedRange == 'W' ? 'M' : 'D' })}>
              {propsPage?.selectedRange == 'D' ? '24H' : propsPage?.selectedRange == 'W' ? '7D' : '30D'}
            </span>
            {
              <>



              </>
            }
          </div>
        </Grid.Column>

      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={6} sWidth={12}>
          <div style={{ margin: '5px' }}>
            <Card>
              <Card.Header title='ESTADOS DE REQUIRIMIENTOS'></Card.Header>
              { propsPage?.data.length == 0 ? 
              <div></div> :
                <CircularChart data={propsPage?.data}></CircularChart>
              }
            </Card>

          </div>
        </Grid.Column>
        <Grid.Column width={6} sWidth={12}>
          <div style={{ margin: '5px' }}>
            <Card>
              <Card.Header title='RELACIÓN APROBAR/RECHAZAR'></Card.Header>
              { propsPage?.data.length == 0 ? 
              <div></div> :
                <CircularChart data={propsPage?.data2}></CircularChart>
              }
            </Card>

          </div>
        </Grid.Column>

      </Grid.Row>

    </Grid>
  );
}

const mapState = (state: any) => (state.dashboardPageReducer)

const mapDispatch = {
  //toggleOn: () => ({ type: 'TOGGLE_IS_ON' }),
}

const connector = connect(mapState, mapDispatch);
export default connector(DashboardPage)
